import { Map } from "immutable";

import SectionAggregation from "../../../../../models/SectionAggregation";

type State = Map<string, SectionAggregation>;

function getSectionAggregation(state: State, sectionId: string) {
  return state ? state.get(sectionId) : undefined;
}

export function getSectionAverageScore(state: State, sectionId: string) {
  const sectionAggregation = getSectionAggregation(state, sectionId);

  if (!sectionAggregation) {
    return;
  }

  return sectionAggregation.get("averageScore");
}
